import { ENV } from "../api/client";

const asStr = (v) => String(v ?? "").trim();
const asNum = (v) => {
    const n = Number(String(v ?? "").trim());
    return Number.isFinite(n) ? n : null;
};

/**
 * Returns the CP defaults payload fields expected by the backend.
 *
 * Fields:
 * - dealer_id
 * - dealer_name
 * - selling_location_id
 * - selling_location_name
 * - profile_additionalInformationGroupId
 */
export function getCpPayloadByIsUS(isUS) {
    const useNonUS = !isUS;

    const dealer_id = useNonUS
        ? asNum(ENV.CP_NONUS_DEALER_ID ?? ENV.CP_DEALER_ID)
        : asNum(ENV.CP_DEALER_ID);

    const dealer_name = useNonUS
        ? asStr(ENV.CP_NONUS_DEALER_NAME ?? ENV.CP_DEALER_NAME)
        : asStr(ENV.CP_DEALER_NAME);

    const selling_location_id = useNonUS
        ? asNum(ENV.CP_NONUS_SELLING_LOCATION_ID ?? ENV.CP_SELLING_LOCATION_ID)
        : asNum(ENV.CP_SELLING_LOCATION_ID);

    const selling_location_name = useNonUS
        ? asStr(ENV.CP_NONUS_SELLING_LOCATION_NAME ?? ENV.CP_SELLING_LOCATION_NAME)
        : asStr(ENV.CP_SELLING_LOCATION_NAME);

    const profile_additionalInformationGroupId = useNonUS
        ? asStr(ENV.CP_NONUS_INFO_GROUPID ?? ENV.CP_INFO_GROUPID)
        : asStr(ENV.CP_INFO_GROUPID);

    return {
        dealer_id,
        dealer_name,
        selling_location_id,
        selling_location_name,
        profile_additionalInformationGroupId,
    };
}
